import styled, { css } from 'styled-components';

import { alignText } from 'utils/constants';

import { AlignText, ThemeColors } from 'types';

export interface TextProps {
  weight?: number;
  color?: ThemeColors;
  lineHeight?: number;
  size?: number;
  align?: AlignText;
}

const Text = styled.p<TextProps>`
  margin: 0;
  padding: 0;

  ${({
    weight = 400,
    color = 'mirage',
    lineHeight = 1.5,
    size = 1.25,
    align = 'left',
    theme,
  }) => css`
    font-weight: ${weight};
    color: ${theme.colors[color]};
    line-height: ${lineHeight};
    font-size: ${size}em;
    text-align: ${alignText[align]};
  `}
`;

export default Text;
